import React, { useEffect, useState } from 'react';
import { DollarSignIcon, ArrowRightIcon, BuildingIcon, HandshakeIcon } from 'lucide-react';
export const Services = () => {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);
  const [activeFeature, setActiveFeature] = useState(0);
  const [autoplay, setAutoplay] = useState(true);
  const services = [{
    id: 1,
    title: 'EMD Funding',
    icon: <DollarSignIcon className="h-6 w-6 sm:h-8 sm:w-8" data-id="element-474" />,
    description: 'Get earnest money deposit funding for your deals.',
    details: 'Our EMD funding service delivers the essential capital real estate wholesalers need to secure their transactions efficiently with no credit checks.',
    color: 'from-[#c9a875] to-[#b08e5c]',
    features: ['Same-day funding available', 'No credit check required', 'Zero paperwork hassle', 'Funds wired directly to title', 'Simple approval process']
  }, {
    id: 2,
    title: 'Double Closing',
    icon: <BuildingIcon className="h-8 w-8" data-id="element-475" />,
    description: 'We fund both sides of your transaction seamlessly.',
    details: 'Our double closing funding allows you to purchase and sell a property on the same day without using your own capital or revealing your profit.',
    color: 'from-[#c9a875] to-[#b08e5c]',
    features: ['100% of purchase price funded', 'Privacy between buyer and seller', 'All closing costs covered', 'No money out of pocket', 'Same-day closings']
  }, {
    id: 3,
    title: 'Stack Method',
    icon: <HandshakeIcon className="h-8 w-8" data-id="element-476" />,
    description: "Leverage our funding alongside your end buyer's funds.",
    details: 'Our Stack Method allows wholesalers to maximize profits by coordinating with end buyers and lenders for a streamlined funding process with minimal risk.',
    color: 'from-[#c9a875] to-[#b08e5c]',
    features: ['Submit your request with all information', 'Wait for request to be approved by our team', 'Connect us with lender to verify requirements', 'Have title sign our irrevocable instructions', 'We fund as soon as the lender funds are sent in!']
  }];
  useEffect(() => {
    if (!autoplay) return;
    const interval = setInterval(() => {
      setActiveFeature(prev => {
        const service = services.find(s => s.id === hoveredCard);
        if (!service) return prev;
        return (prev + 1) % service.features.length;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, [autoplay, services, hoveredCard]);
  return <section id="services" className="bg-[#f2efeb] py-14 md:py-20 border-t border-[#d9d3cb]" data-id="element-477">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-478">
        <div className="text-center mb-16 sm:mb-20" data-id="element-479">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 font-serif-display text-[#2b2826]" data-id="element-480">
            Funding Solutions For{' '}
            <span className="text-[#c9a875]" data-id="element-481">Every Deal</span>
          </h2>
          <p className="text-lg sm:text-xl text-[#2b2826]/80 max-w-3xl mx-auto" data-id="element-482">
            Fast, transparent, and reliable funding solutions to help you close
            more deals and grow your wholesaling business without the stress or
            hassle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8" data-id="element-483">
          {services.map((service, index) => <div key={index} className="bg-[#2b2826] rounded-3xl border border-[#403a35] overflow-hidden group relative transition-all duration-500 hover:border-[#c9a875]/50" data-id="element-484">
              {/* Hover gradient effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#c9a875]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-485" />

              <div className="p-8 sm:p-10 relative z-10" data-id="element-486">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-[#1c1916] border border-[#403a35] flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500" data-id="element-487">
                  <div className="text-[#c9a875]" data-id="element-488">{service.icon}</div>
                </div>

                <h3 className="text-2xl font-bold mb-4 text-[#f2efeb]" data-id="element-489">
                  {service.title}
                </h3>
                <p className="text-[#f2efeb]/70 mb-8 min-h-[80px]" data-id="element-490">
                  {service.description}
                </p>
                <div className="mt-auto flex justify-between items-center pt-6 border-t border-[#403a35]" data-id="element-491">
                  <button className="flex items-center text-[#c9a875] font-medium group text-sm sm:text-base" data-id="element-492">
                    Learn More{' '}
                    <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-493" />
                  </button>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-16 sm:mt-20 text-center" data-id="element-494">
          <p className="text-[#2b2826]/80 mb-6 sm:mb-8 text-lg" data-id="element-495">
            Not sure which funding option is right for your deal?
          </p>
          <a href="#funding-form" className="whitespace-nowrap inline-flex items-center gap-2 sm:gap-2.5 bg-[#c9a875] text-white font-medium py-3 px-6 sm:py-4 sm:px-8 rounded-full hover:bg-[#b08e5c] transition-all text-sm sm:text-base" data-id="element-496">
            Talk to a Funding Specialist
            <ArrowRightIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-497" />
          </a>
        </div>
      </div>
    </section>;
};